import * as React from 'react';
import { post } from '../../webapi';
import { IPagination, IBasePaginationProps, IBasePaginationState } from '../../Model/interfaces';
import { TemplateData, GetTemplatesParams, TagHolderTypes } from '../../Model/core';
import { Pagination } from '../Pagination/Pagination';
declare const wdShop: any;

export interface TemplatesListProps extends IBasePaginationProps {
    currentPageId: number;
    tagType: TagHolderTypes;
}

export class TemplatesList extends React.Component<TemplatesListProps, IBasePaginationState<TemplateData>> {
    constructor(props: TemplatesListProps) {
        super(props);

        this.state = { items: [] };

        this.fetchTemplates = this.fetchTemplates.bind(this);
    }


    async fetchTemplates(currentPage: number) {
        const { itemsPerPage, currentPageId, tagType } = this.props;
        const body: GetTemplatesParams = {
            CurrentPage: currentPage,
            ItemsPerPage: itemsPerPage,
            CurrentPageId: currentPageId,
            TagType: tagType
        };
        const result = await post<IPagination<TemplateData>>(
            '/blApi/GetTemplates',
            body
        );
        this.setState({ items: result?.Items ?? [] });

        return result?.PaginationData ?? null;
    }

    render() {
        const { items } = this.state;
        return (
            <>
                <Templates items={items} />
                <Pagination onPageChange={this.fetchTemplates} runOnMount={true} queryKey="templates" />
            </>
        );
    }
}
type TemplatesProps = {
    items: TemplateData[];
};

const Templates = ({ items }: TemplatesProps) => {
    return (
        <ul className="bl-template-list">
            {items.map((item) => <Article key={item.PageId} item={item} />)}
        </ul>
    );
};

type ArticleProps = {
    item: TemplateData;
};
const Article = ({ item }: ArticleProps) => {
    const handleAddToCart = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        wdShop.addToCart(item.ArticleNr, 1);
    };
    const link = `<a href=${item.Link} title=${item.Title}>Läs mer »</a>`;
    return (
        <li className="item">
            <div className="row">
                <div className="col-12 col-md-6 col-lg-2 img-container">
                    <img src={item.ImageUrl} title={item.Title} />
                </div>
                <div className="col-12 col-md-12 col-lg-8 text-container">
                    <h5 dangerouslySetInnerHTML={{ __html: item.Title }}></h5>
                    <p dangerouslySetInnerHTML={{ __html: item.Description + ' ' + link }}></p>
                </div>
                <div className="col-12 col-md-6 col-lg-2 product-container">
                    <div className="text-center">
                        <div className="w-100 price-box" dangerouslySetInnerHTML={{ __html: item.Price }}>
                        </div>
                        <div className="w-100">
                            {/* <button
                                type="button"
                                className="bl-btn bl-btn-orange"
                                onClick={handleAddToCart}
                            >
                                Lägg i varukorgen
                            </button> */}
                            <a className="bl-btn bl-btn-orange d-block" href={item.Link} title={item.Title}>Beställ</a>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    );
};